import { EnergyLabel } from "@omni/types/components/product/energyLabel/energyLabel.type";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { EnergyLabelContextProvider } from "@/components/Product/energyLabel/context/energyLabel.context";

type Props = {
    energyLabel: EnergyLabel | undefined;
    className?: string;
    children: ReactNode;
};

export const Base = ({ energyLabel, className, children }: Props) => {
    if (!energyLabel) return null;

    return (
        <div className={cn(className)}>
            <EnergyLabelContextProvider
                eprelId={energyLabel.eprelId}
                label={energyLabel.label}
                labelNested={energyLabel.labelNested}
            >
                {children}
            </EnergyLabelContextProvider>
        </div>
    );
};
